var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoaches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "18px",
    viewBox: "0 0 25 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2EB73AAE-7988-494F-9084-5FABD015E3EA@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coach",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-(-gym-owner-)-",
    transform: "translate(-29.000000, -501.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SIDEBAR",
    transform: "translate(-1.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main",
    transform: "translate(9.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,399 L45,399 L45,415 L40.027027,415 C39.7521321,412.521143 38.3987237,410.345905 36.4009009,409.171429 C38.3624625,407.20419 38.5071622,403.855238 36.7237988,401.691048 C34.9407808,399.527238 31.9045045,399.367619 29.9429429,401.334857 C27.981036,403.302095 27.8366817,406.651048 29.6196997,408.815238 C29.7222673,408.939429 29.830015,409.058286 29.9429429,409.171429 C27.9316517,410.336381 26.5644294,412.513524 26.2822823,415 L22,415 L22,399 Z M21.9541985,416 L45.0458015,416 C45.5728372,416 46,415.552333 46,415 L46,399 C46,398.447667 45.5728372,398 45.0458015,398 L21.9541985,398 C21.4271628,398 21,398.447667 21,399 L21,415 C21,415.552333 21.4271628,416 21.9541985,416 L21.9541985,416 Z",
    id: "Fill-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoaches);
export default __webpack_public_path__ + "static/media/coaches.56cd69c1783df033735828ba2b839fb0.svg";
export { ForwardRef as ReactComponent };